/**
 * Single source of truth for the ProvisionMart Terms & Conditions text
 * shown on every authentication / signup screen. Keep this file plain text
 * (no JSX) so it can be reused by the mobile shell, emails, and PDFs later.
 */

export const TERMS_EFFECTIVE_DATE = 'April 18, 2026';

export const TERMS_AND_CONDITIONS = `TERMS AND CONDITIONS
ProvisionMart

Effective Date: ${TERMS_EFFECTIVE_DATE}

Welcome to ProvisionMart. By accessing or using our platform, you agree to comply with and be bound by the following Terms and Conditions.

========================================
 1. PLATFORM OVERVIEW
========================================
ProvisionMart is a technology platform that connects customers with local stores, restaurants, and delivery partners. We facilitate ordering and delivery services but do not manufacture, store, or directly sell products or food.

========================================
 2. USER ACCOUNTS
========================================
• Users must provide accurate and complete information during registration.
• Users are responsible for maintaining confidentiality of their account credentials.
• ProvisionMart reserves the right to suspend or terminate accounts for misuse, fraud, or violation of terms.

========================================
 3. CUSTOMER TERMS
========================================
• Customers can browse products, place orders, and track deliveries.
• Orders cannot be cancelled once accepted or dispatched by the store/restaurant.
• Customers must provide accurate delivery address and contact details.
• Payments can be made via online methods or cash on delivery.
• Refunds will be processed as per applicable refund policies.
• Misuse of services (fake orders, abuse) may lead to account suspension.

========================================
 4. STORE / RESTAURANT TERMS
========================================
• Stores and restaurants must provide accurate product/menu details, pricing, and availability.
• They are responsible for quality, packaging, hygiene, and compliance with applicable laws (e.g., FSSAI, GST).
• Orders must be accepted or rejected within a reasonable time.
• Repeated cancellations or delays may result in penalties or removal from the platform.
• Commission fees may be charged by ProvisionMart.

========================================
 5. DELIVERY PARTNER TERMS
========================================
• Delivery partners must ensure timely and safe delivery of orders.
• They must maintain professional behavior with customers and stores.
• They are responsible for maintaining valid documents, licenses, and compliance with traffic laws.
• Delivery partners must provide accurate real-time location updates during delivery.
• Any misconduct, fraud, or negligence may lead to termination of account.

========================================
 6. PAYMENTS AND COMMISSIONS
========================================
• ProvisionMart may charge service or commission fees from stores/restaurants.
• Delivery charges may vary based on distance, demand, and availability.
• Payment settlements to stores/restaurants will be processed periodically.

========================================
 7. CANCELLATION AND REFUNDS
========================================
• Orders cannot be cancelled after preparation or dispatch.
• Refunds (if applicable) will be processed within a reasonable time.
• Refund eligibility depends on issue verification.

========================================
 8. LIABILITY LIMITATION
========================================
• ProvisionMart acts only as an intermediary platform.
• We are not liable for product quality, food safety, delays, or third-party issues.
• Our liability is limited to the value of the order placed.

========================================
 9. PROHIBITED ACTIVITIES
========================================
Users shall not:
• Engage in fraudulent activities
• Provide false information
• Abuse or harass other users
• Misuse the platform in any unlawful manner

========================================
10. TERMINATION
========================================
ProvisionMart reserves the right to suspend or terminate any account that violates these terms.

========================================
11. PRIVACY
========================================
User data will be handled as per our Privacy Policy.

========================================
12. CHANGES TO TERMS
========================================
ProvisionMart may update these Terms at any time. Continued use of the platform implies acceptance of updated terms.

========================================
13. GOVERNING LAW
========================================
These Terms shall be governed by the laws of India.

========================================
ACCEPTANCE
========================================
By using ProvisionMart, you acknowledge that you have read, understood, and agree to these Terms and Conditions.
`;

